const EntityHome = () => import(/* webpackChunkName: "entityHome" */ '@/components/EntityHome')
const Editor = () => import(/* webpackChunkName: "entityHome" */ '@/pages/userProfile/Editor')
const routes = [
    {
        path: '/userProfile',
        component: EntityHome,
        meta: { breadCrumb: 'User Profile' },
        children: [
            {
                path: '',
                name: 'userProfile',
                component: Editor,
            },
        ],
    },
]

export default routes
